/*
 * Copyright 2025 ixPilot Teknoloji A.Ş. (ixpilot2021@gmail.com)
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, modification, or distribution of this software,
 * via any medium, is strictly prohibited.
 *
 * Developed and maintained by ixPilot Teknoloji A.Ş.
 */


// Traccar category -> Türkçe etiket
const ARAC_TIPI_LABELS = {
  default: "Varsayılan",
  car: "Araba",
  truck: "Kamyon",
  motorcycle: "Motosiklet",
  bicycle: "Bisiklet",
  boat: "Tekne",
  plane: "Uçak",
  helicopter: "Helikopter",
  person: "İnsan",
  animal: "Hayvan",
};

const baseColumnsAraclar = [
  { Header: "ID", accessor: "id" },
  { Header: "Satış Tarihi", accessor: "satis_tarihi", sortable: true },
  { Header: "Satış Türü", accessor: "satis_turu" },
  { Header: "Kullanım", accessor: "kullanim_durumu" },
  { Header: "Firma", accessor: "firma_ismi" },
  { Header: "İş Ortağı", accessor: "is_ortagi" },
  { Header: "Plaka", accessor: "plaka" },
  { Header: "SIM No", accessor: "sim_no" },
  { Header: "IMEI", accessor: "imei" },
  { Header: "Cihaz Tipi", accessor: "cihaz_tipi" },
  { Header: "Araç Tipi", accessor: "arac_tipi", Cell: ({ value }) => ARAC_TIPI_LABELS[value] || value || "Varsayılan" },
  { Header: "Abonelik Durumu", accessor: "abonelik_durumu" },
  { Header: "Montaj Per.", accessor: "montaj_personeli" },
  { Header: "Not", accessor: "notlar" },
  { Header: "Son Bağlantı", accessor: "son_baglanti" },
  { Header: "UETDS", accessor: "uetds" },
];

// Role göre kolonları filtrele - bayi rolünde "İş Ortağı" kolonunu gizle
export const getColumnsAraclar = (userRole) => {
  if (userRole === "bayi") {
    return baseColumnsAraclar.filter(col => col.accessor !== "is_ortagi");
  }
  return baseColumnsAraclar;
};

// Backward compatibility için default export
export const columnsAraclar = baseColumnsAraclar;